import { DecimalPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SchedulerSettingsService } from '../../services/scheduler-settings.service';
import { ISchedulerSettings } from '../../interfaces/scheduler-settings.interface';

@Component({
    standalone: false,
    selector: 'app-threads-scheduler-settings-form',
    templateUrl: './threads-scheduler-settings-form.component.html',
    styleUrls: ['./threads-scheduler-settings-form.component.scss']
})
export class ThreadsSchedulerSettingsFormComponent implements OnInit {
    _settings: ISchedulerSettings;

    formGroup: FormGroup;

    turnOnThreadsSchedulerControl = new FormControl(false);

    minOptimalThreadsPerEc2InstanceCount = 1;
    maxOptimalThreadsPerEc2InstanceCount = 10;

    minThreadsIncreaseIntervalMin = 0.1;
    maxThreadsIncreaseIntervalMin = 60;

    optimalThreadsPerEc2InstanceCountControl = new FormControl(1, [
        Validators.required,
        Validators.min(this.minOptimalThreadsPerEc2InstanceCount),
        Validators.max(this.maxOptimalThreadsPerEc2InstanceCount),
        Validators.pattern('^[0-9]*$')
    ]);

    threadsIncreaseIntervalMinControl = new FormControl(30, [
        Validators.required,
        Validators.min(this.minThreadsIncreaseIntervalMin),
        Validators.max(this.maxThreadsIncreaseIntervalMin),
        Validators.pattern('^\\d+.?\\d*$')
    ]);

    get settings(): ISchedulerSettings {
        return this._settings;
    }

    @Input()
    set settings(value: ISchedulerSettings) {
        this._settings = value;
        this.setFormData(this._settings);
    }

    constructor(
        protected readonly formBuilder: FormBuilder,
        private decimalPipe: DecimalPipe,
        protected readonly schedulerSettingsService: SchedulerSettingsService
    ) {
        this.formGroup = formBuilder.group({
            threadsIncreaseSchedulerActive: this.turnOnThreadsSchedulerControl,
            optimalThreadsPerEc2InstanceCount: this.optimalThreadsPerEc2InstanceCountControl,
            threadsIncreaseIntervalMin: this.threadsIncreaseIntervalMinControl
        });
    }

    ngOnInit(): void {}

    formatInput() {
        const currentValue = Number(this.threadsIncreaseIntervalMinControl.value);
        const formattedValue = this.decimalPipe.transform(currentValue, '1.2-2');
        this.threadsIncreaseIntervalMinControl.setValue(formattedValue ? Number(formattedValue) : currentValue);
    }

    setFormData(scheduleSettings: ISchedulerSettings) {
        if (!scheduleSettings) {
            return;
        }
        this.formGroup.patchValue(scheduleSettings);
    }
}
